import { useQuery } from '@tanstack/react-query';
import { TermsLayout } from 'client/modules/terms/layout/terms-layout/TermsLayout';
import { CacheKey } from 'infra/interfaces/cache';
import { getPublicLastedTerm } from 'infra/repositories/term';
import { TermTypes } from 'infra/repositories/term/types';

export const PrivacyPolicyPage = () => {
	const { data: currentTerm } = useQuery({
		queryKey: [CacheKey.PRIVACY_POLICY],
		queryFn: () => getPublicLastedTerm({ type: TermTypes.POLICY_PRIVACY }),
		staleTime: Infinity,
	});

	return (
		<TermsLayout
			className="animate-card-entry"
			type={currentTerm?.type}
			description={currentTerm?.description}
			readOnly
		/>
	);
};
